"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSPagination = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = tslib_1.__importStar(require("react"));
var BDSPagination_style_1 = require("./BDSPagination.style");
var BDSFontIcon_1 = require("../../Basic/BDSFontIcon/BDSFontIcon");
var array_utils_1 = require("../../../../utils/array.utils");
var BDSSelectBox_1 = require("../../Elements/BDSSelectBox/BDSSelectBox");
var BDSPagination = function (props) {
    var totalDataCount = props.totalDataCount, paginationCallback = props.paginationCallback, pageDataCountCallback = props.pageDataCountCallback, _a = props.language, language = _a === void 0 ? 'ko' : _a, countPerPage = props.countPerPage, activePage = props.activePage;
    var _b = react_1.useState(typeof activePage === 'number' && activePage > 0 ? activePage : 1), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = react_1.useState(countPerPage), pageDataCount = _c[0], setPageDataCount = _c[1];
    // 페이지 버튼 숫자의 십 이상의 자릿수
    var _d = react_1.useState(0), pageTerm = _d[0], setPageTerm = _d[1];
    var fromDataCount = react_1.useMemo(function () { return currentPage * pageDataCount - pageDataCount + 1; }, [currentPage, pageDataCount]);
    var toDataCount = react_1.useMemo(function () { return (currentPage * pageDataCount < totalDataCount ? currentPage * pageDataCount : totalDataCount); }, [currentPage, pageDataCount, totalDataCount]);
    var pageBtnCount = react_1.useMemo(function () { return Math.ceil(totalDataCount / pageDataCount); }, [totalDataCount, pageDataCount]);
    var maxPageBtnCount = 10;
    var handleClickPage = react_1.useCallback(function (clickedPage) {
        if (clickedPage && clickedPage <= pageBtnCount) {
            setCurrentPage(clickedPage);
            paginationCallback(clickedPage);
        }
    }, [pageBtnCount]);
    react_1.useEffect(function () {
        setCurrentPage(activePage !== null && activePage !== void 0 ? activePage : 1);
        setPageDataCount(countPerPage !== null && countPerPage !== void 0 ? countPerPage : 10);
    }, [totalDataCount, countPerPage]);
    return (jsx_runtime_1.jsxs("div", tslib_1.__assign({ css: BDSPagination_style_1.baseCss }, { children: [totalDataCount > pageDataCount && (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [currentPage > 1 && (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "btn" }, { children: jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, { name: "ic-arrow-left", color: "#7e8696", size: "20px", handleClick: function () {
                                if (currentPage - 1 <= pageTerm)
                                    setPageTerm(function (prevState) { return prevState - maxPageBtnCount; });
                                handleClickPage(currentPage - 1);
                            } }, void 0) }), void 0)),
                    Array(pageBtnCount - pageTerm > maxPageBtnCount ? maxPageBtnCount : pageBtnCount - pageTerm)
                        .fill('')
                        .map(function (_, i) { return (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "btn page-number-btn " + (currentPage === i + 1 + pageTerm ? 'clicked-btn' : ''), onClick: function () {
                            handleClickPage(i + 1 + pageTerm);
                        } }, { children: i + 1 + pageTerm }), array_utils_1.getUniqKey('BDSPagination', i + 1 + pageTerm))); }),
                    currentPage < pageBtnCount && (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "btn" }, { children: jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, { name: "ic-arrow-right", color: "#7e8696", size: "20px", handleClick: function () {
                                if (pageTerm + maxPageBtnCount < currentPage + 1)
                                    setPageTerm(function (prevState) { return prevState + maxPageBtnCount; });
                                handleClickPage(currentPage + 1);
                            } }, void 0) }), void 0))] }, void 0)),
            jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "data-list-info-wrapper" }, { children: [jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "padding data-list-count" }, { children: language === 'ko'
                            ? "\uC804\uCCB4 " + totalDataCount + "\uAC1C \uC911 " + fromDataCount + " " + (fromDataCount !== toDataCount ? "~ " + toDataCount : '')
                            : fromDataCount + " " + (fromDataCount !== toDataCount ? "~ " + toDataCount : '') + " of Total " + totalDataCount + "EA" }), void 0),
                    jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "padding" }, { children: language === 'ko' ? '목록개수' : 'Number of lists' }), void 0),
                    jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "select-box padding" }, { children: jsx_runtime_1.jsx(BDSSelectBox_1.BDSSelectBox, { list: [
                                {
                                    label: '10',
                                    value: '10',
                                },
                                {
                                    label: '20',
                                    value: '20',
                                },
                                {
                                    label: '50',
                                    value: '50',
                                },
                                {
                                    label: '100',
                                    value: '100',
                                },
                            ], defaultValue: { label: String(pageDataCount), value: String(pageDataCount) }, displayValue: function (item) {
                                return item.label;
                            }, handleUpdate: function (item) {
                                setCurrentPage(1);
                                setPageTerm(0);
                                setPageDataCount(parseInt(item.value, 10));
                                pageDataCountCallback(parseInt(item.value, 10));
                            }, isSelected: function (item) {
                                return item.value === pageDataCount;
                            } }, void 0) }), void 0)] }), void 0)] }), void 0));
};
exports.BDSPagination = BDSPagination;
